const HEALTH_CHECK_PATH = '/health.json';
const HEALTH_CHECK_TIMEOUT_MS = 2500;
const CACHE_TTL_MS = 10 * 60 * 1000;
const failures = [];
const logFailure = (url, reason) => {
    failures.push({ url, reason, timestamp: Date.now() });
    console.warn(`[endpoint-health] ${url} failed health check: ${reason}`);
};
export const getEndpointHealthFailures = () => failures;
export const checkEndpointHealth = async (baseUrl, timeoutMs = HEALTH_CHECK_TIMEOUT_MS) => {
    const healthUrl = `${baseUrl.replace(/\/$/, '')}${HEALTH_CHECK_PATH}`;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        const res = await fetch(healthUrl, { signal: controller.signal, cache: 'no-store' });
        if (!res.ok) {
            logFailure(healthUrl, `HTTP ${res.status}`);
            return false;
        }
        const data = await res.json();
        if (data?.status !== 'ok') {
            logFailure(healthUrl, `unexpected content: ${JSON.stringify(data)}`);
            return false;
        }
        return true;
    }
    catch (err) {
        logFailure(healthUrl, err instanceof Error ? err.message : String(err));
        return false;
    }
    finally {
        clearTimeout(timer);
    }
};
export const selectWorkingBase = async (primary, fallbacks = []) => {
    if (await checkEndpointHealth(primary))
        return primary;
    for (const fallback of fallbacks) {
        if (await checkEndpointHealth(fallback))
            return fallback;
    }
    return primary;
};
const readCache = (storageKey) => {
    if (typeof sessionStorage === 'undefined')
        return null;
    try {
        const raw = sessionStorage.getItem(storageKey);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (Date.now() - parsed.timestamp > CACHE_TTL_MS)
            return null;
        return parsed;
    }
    catch {
        return null;
    }
};
const writeCache = (storageKey, primary, resolved) => {
    if (typeof sessionStorage === 'undefined')
        return;
    try {
        const entry = { primary, resolved, timestamp: Date.now() };
        sessionStorage.setItem(storageKey, JSON.stringify(entry));
    }
    catch {
        // sessionStorage may be unavailable; skipping cache is not fatal
    }
};
export const selectWorkingBaseCached = async (storageKey, primary, fallbacks = []) => {
    const cached = readCache(storageKey);
    if (cached && cached.primary === primary)
        return cached.resolved;
    const resolved = await selectWorkingBase(primary, fallbacks);
    writeCache(storageKey, primary, resolved);
    return resolved;
};
